module.exports = __webpack_public_path__ + "img/bg_brand.2712c312.jpg";